// extracted by mini-css-extract-plugin
module.exports = {"section":"sobreHype_section__Xjema","text":"sobreHype_text__QHody","info":"sobreHype_info__HbEYB","itemInfo":"sobreHype_itemInfo__nWm0m","image":"sobreHype_image__l6smm"};